import { render, staticRenderFns } from "./EditBrandDescriptionDialog.vue?vue&type=template&id=2d865f26&scoped=true"
import script from "./EditBrandDescriptionDialog.vue?vue&type=script&lang=js"
export * from "./EditBrandDescriptionDialog.vue?vue&type=script&lang=js"
import style0 from "./EditBrandDescriptionDialog.vue?vue&type=style&index=0&id=2d865f26&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d865f26",
  null
  
)

export default component.exports